import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { CookieService } from '../app/shared/services/cookie.service'
import { secureStorage } from './shared/services/encryption/secureservice';
import { BehaviourSubjectService } from './shared/services/behaviour-subject.service';


@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  sub: Subscription = new Subscription();
  private socket: WebSocket | null = null;
  private messageSubject = new Subject<any>();
  private connectionStatusSubject = new BehaviorSubject<boolean>(false); // false = disconnected

  public connectionStatus$ = this.connectionStatusSubject.asObservable();
  // private kycMessageSubject = new Subject<any>();
constructor( private spinner: NgxSpinnerService,
  private behaviorService: BehaviourSubjectService,
  private toastrService: ToastrService,private ssrcookieService: CookieService,
    private localStorage: secureStorage,){

}
  connect(url: string): void {
  this.socket = new WebSocket(url);

  this.socket.onopen = () => {
    console.log('WebSocket connected');
    // this.sub.add(this.connectionStatusSubject.next(true)); // Notify that connection is established
    this.sub.add(this.behaviorService.websocketWhat.next(true)); // Notify that connection is established
  };

  this.socket.onmessage = (event) => {
    const data = JSON.parse(event.data);
    console.log("get message ", data);
    this.messageSubject.next(data);
    this.disconnect(); 
  };

  this.socket.onerror = (error) => {
    console.error('WebSocket error:', error);
    // this.connectionStatusSubject.next(false); 
    this.spinner.hide();
    this.toastrService.warning('Unable to Process the Request.');
  };

  // Optional: handle disconnection
  this.socket.onclose = () => {
    console.log('WebSocket closed');
    this.messageSubject.next('close')
    this.sub.add(this.behaviorService.websocketWhat.next(false)); 
  };
}


  closeConnection(): void {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      console.log('closeConnection------->')
      this.sub.add(this.behaviorService.websocketWhat.next(false)); 
      // this.sub.add(this.connectionStatusSubject.next(false));
      this.socket.close();
      console.log('WebSocket manually closed');
    }
  }
  getMessages(): Observable<any> {
    return this.messageSubject.asObservable();
  }

  sendMessage(message: any): void {
    if (this.socket?.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(message));
    } else {
      console.warn('WebSocket not open. Message not sent.');
    }
  }

  disconnect(): void {
    console.log("Websocket disconnected !!!");
    this.sub.add(this.behaviorService.websocketWhat.next(false)); 
    // this.sub.add(this.messageSubject.next(null))
    // this.behaviorService.websocketWhat.unsubscribe();
    this.socket?.close();
    this.socket = null;
  }

}
